import state320 from "./320";
import state321 from "./321";

// TODO: erre átállni + require.context

export default {
    "320": state320,
    "321": state321,
};
